import { Collection } from 'modules/core/lib/mobx-rest'

import Category from 'modules/expenses/store/models/Category'
import expensesCategoriesContractsTaxonomies from 'modules/payroll_bundle/store/collections/expensesCategoriesContractsTaxonomies'

class Categories extends Collection<Category> {
  get cacheKey(): string {
    return 'categories'
  }

  model() {
    return Category
  }

  async syncWithPayroll() {
    const payrollCategories = await expensesCategoriesContractsTaxonomies.existingTaxonomies()

    this.forEach((categoryModel) => {
      if (payrollCategories.some((element) => element === categoryModel.attributes.id)) {
        categoryModel.set({ payroll_sync: true })
      }
    })
  }
}

const singleton: Categories = new Categories()

export default singleton
